module.exports = "/_next/static/images/SantaBarbaraLogo-63ee499cf09cae2b9c6d7b7d87baac24.png";